<template>
  <ListResult
    :type="'video'"
    :course="video"
    :gradient="gradient"
    :tileImg="`${$getPlaylistBackground(video.objectID)}`"
    :duration="duration"
    :difficulty="''"
    :link="{}"
    :parent="parent"
    :learningAreaColor="getLearningAreaColor(parent)"
    :learningArea="getLearningArea(parent)"
    :instructorAtTheEnd="true"
  />
</template>

<script>
import ListResult from '@/components/search/ListResult.vue'
import { getLearningAreaColor, getLearningArea } from '@/helpers'

export default {
  name: 'VideoListResult',
  components: {
    ListResult,
  },
  data: () => {
    return {
      getLearningAreaColor,
      getLearningArea,
    }
  },
  props: {
    video: {
      type: Object,
      required: true,
    },
    gradient: {
      type: String,
      required: true,
    },
    backgroundImg: {
      type: String,
      required: false,
    },
    duration: {
      type: String,
      required: true,
    },
    parent: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.video-list-result-style {
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding-right: 30px;
  @include mobile {
    flex-wrap: nowrap;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  &__tile-img {
    height: 100%;
    width: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--white);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  &__icon {
    font-size: 3rem;
  }
  &__title {
    width: 50%;
    color: var(--white);
    font-size: 1.2rem;
    margin: 0 auto 0 20px;
    font-weight: bold;
  }
  &__duration {
    white-space: nowrap;
    background: black;
    padding: 5px 10px;
    font-size: 0.8rem;
    border-radius: 10px;
    color: var(--white);
  }
  &__instructor {
    font-weight: normal;
    font-size: 0.8rem;
    margin-top: 10px;
  }
  &__btn-wrapper {
    display: none;
    width: 20%;
    margin: 0 0 0 auto;
    @include mobile {
      display: block;
    }
  }
}
</style>
